// A plain string entry is required (AND). A nested array means "any of" (OR).
export type RequiredPermissions = (string[] | string)[];

export const hasRequiredPermissions = (
  userPermissions: string[],
  requiredPermissions: RequiredPermissions,
): boolean =>
  requiredPermissions.length === 0 ||
  requiredPermissions.every(it =>
    Array.isArray(it) ? it.some(p => userPermissions.includes(p)) : userPermissions.includes(it),
  );
